import {BetData} from 'utils/types';

// TODO: all of this

/**
 * Provides array of odds to fill bet widget
 * @param matchId MongoDB match Id (provided by URL)
 */

const useBetData = (): BetData => ({
  /*
  provider: {
    name: 'Στοίχημαν',
    imageUrlLight: '', 
    imageUrlDark: '', 
    clickUrl: 'https://www.stoiximan.gr/', // TODO: assert URL
  },
  */
  odds: [
    {
      type: 'result',
      title: '1 X 2',
      values: [
        {
          label: 'ΟΛΥ',
          value: 1.73,
        },
        {
          label: 'Χ',
          value: 1.73,
        },
        {
          label: 'ΟΦΗ',
          value: 1.73,
        },
      ],
    },
    {
      type: 'handicap',
      title: 'ΠΛΕΟΝΕΚΤΗΜΑ 0:1',
      values: [
        {
          label: 'ΟΛΥ',
          value: 1.73,
        },
        {
          label: 'Χ',
          value: 1.73,
        },
        {
          label: 'ΟΦΗ',
          value: 1.73,
        },
      ],
    },
    {
      type: 'overunder',
      title: 'ΠΑΝΩ / ΚΑΤΩ 2.5',
      values: [
        {
          label: 'ΟΛΥ',
          value: 1.73,
        },
        {
          label: 'ΟΦΗ',
          value: 1.73,
        },
      ],
    },
    {
      type: 'exact',
      title: 'ΑΚΡΙΒΕΣ ΣΚΟΡ',
      values: [
        {
          label: '1:0',
          value: 1.73,
        },
        {
          label: '2:0',
          value: 1.73,
        },
        {
          label: '3:0',
          value: 1.73,
        },
        {
          label: '0:1',
          value: 1.73,
        },
        {
          label: '0:2',
          value: 1.73,
        },
        {
          label: '0:3',
          value: 1.73,
        },
        {
          label: '1:1',
          value: 1.73,
        },
        {
          label: '2:2',
          value: 1.73,
        },
        {
          label: '3:3',
          value: 1.73,
        },
        {
          label: '1:2',
          value: 1.73,
        },
        {
          label: '1:3',
          value: 1.73,
        },
        {
          label: '2:1',
          value: 1.73,
        },
        {
          label: '2:3',
          value: 1.73,
        },
        {
          label: '3:1',
          value: 1.73,
        },
        {
          label: '3:2',
          value: 1.73,
        },
        {
          label: '0:0',
          value: 1.73,
        },
      ],
    },
  ],
});

export default useBetData;
